export const fr = {
  HOME: '/',
  CONTENT: '/[...content]',
  NEWS_LISTING: '/infos',
  NEWS_LISTING_BY_SLUG: '/infos/listes/[newsListing]',
  NEWS_CATEGORY: '/infos/categorie',
  NEWS_TAG: '/infos/tag/[tag]',
  ARTICLE: '/infos/[article]',
  MATCH_CENTRE: '/matchs/[team]/rencontres',
  FIXTURES: '/matchs/[team]/rencontres',
  FIXTURES_COMPETITION: '/matchs/[team]/rencontres/[competition]',
  RESULTS: '/matchs/[team]/resultats',
  RESULTS_COMPETITION: '/matchs/[team]/resultats/[competition]',
  RESULTS_COMPETITION_SEASON: '/matchs/[team]/resultats/[competition]/[season]',
  TABLE: '/matchs/[team]/tableau',
  TABLE_COMPETITION: '/matchs/[team]/tableau/[competition]',
  TABLE_COMPETITION_SEASON: '/matchs/[team]/tableau/[competition]/[season]',
  TEAM: '/equipes/[team]',
  PROFILE: '/equipes/[team]/[profile]',
  TEAM_YOUTH: '/equipes/jeunes/[team]',
  PROFILE_YOUTH: '/equipes/jeunes/[team]/[profile]',
  VIDEO_LANDING: '/video',
  VIDEO_DETAIL: '/video/[slug]',
  VIDEO_CATEGORY: '/video/categorie/[category]',
  VIDEO_PLAYLIST_LISTING: '/video/playlists/[slug]',
  VIDEO_PLAYLIST: '/video/playlists/[slug]',
  VIDEO_COLLECTION: '/video/collection/[collection]',
} as const;
